export default __webpack_public_path__ + "static/media/red-dot-flat.bf7e0a87.svg";